import { render, staticRenderFns } from "./TProject.vue?vue&type=template&id=0fe9fdba"
import script from "./TProject.vue?vue&type=script&lang=js"
export * from "./TProject.vue?vue&type=script&lang=js"
import style0 from "./TProject.vue?vue&type=style&index=0&id=0fe9fdba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports